import React, { createContext, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [workData, setWorkData] = useState([]);
  const [workCategoryData, setWorkCategoryData] = useState([]);
  const [error, setError] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [sliderImages, setSliderImages] = useState(null);
  const [mediaData, setMediaData] = useState([]);
  const [officeData, setOfficeData] = useState(null);
  const [acfData, setAcfData] = useState(null);
  const [imageUrls, setImageUrls] = useState({});
  const [mapHtml, setMapHtml] = useState("");
  const [career, setCareer] = useState([]);
  const [careerData, setCareerData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  // const [mediaData, setMediaData] = useState([]);
  const [mediaDataByWorkId, setMediaDataByWorkId] = useState({});
  // const [sliderImages, setSliderImages] = useState([]);
  // const [mediaData, setMediaData] = useState({});

  return (
    <UserContext.Provider
      value={{
        isLoading,
        workData,
        workCategoryData,
        error,
        images,
        selectedCategoryId,
        sliderImages,
        setSliderImages,
        mediaData,
        setMediaData,
        setWorkData,
        setWorkCategoryData,
        setImages,
        setIsLoading,
        setSelectedCategoryId,
        officeData,
        setOfficeData,
        acfData,
        setAcfData,
        imageUrls,
        setImageUrls,
        mapHtml,
        setMapHtml,
        career,
        setCareer,
        careerData,
        setCareerData,
        categories,
        setCategories,
        teamMembers,
        setTeamMembers,
        mediaDataByWorkId,
        setMediaDataByWorkId,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
